import { type ApiContainerType } from '@Model';
import {
    Card,
    Checkbox,
    Grid,
    GridColumn,
    type IGuiBinder,
    NumberInput,
    useAutoConfirmed,
    useProp,
    useTranslate,
} from '@synqo/frontend-component-library';
import { memo } from 'react';

// @ai-generated 2026-10-21T09:24:28+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

interface IProps {
    binder: IGuiBinder<ApiContainerType>;
    usesIndividualManagement: boolean;
}

export const ContainerTypeStockSection = memo(function ContainerTypeStockSection({
    binder,
    usesIndividualManagement,
}: IProps) {
    const i18n = useTranslate('');

    const isExternalField = useAutoConfirmed<ApiContainerType, boolean>(binder, 'is_external');
    const usesIndividualManagementField = useAutoConfirmed<ApiContainerType, boolean>(
        binder,
        'uses_individual_management',
    );
    const totalCountField = useProp<ApiContainerType, number>(binder, 'total_count');

    return (
        <Card name="ContainerTypeStock" border="withoutBorder">
            <Checkbox {...isExternalField} label={i18n('Externer Typ')} />
            <Checkbox {...usesIndividualManagementField} label={i18n('Einzelverwaltung')} />
            {/* A type tracked per container takes its count from those records, not from this field. */}
            {!usesIndividualManagement && (
                <Grid>
                    <GridColumn span={4}>
                        <NumberInput {...totalCountField} label={i18n('Gesamtbestand')} />
                    </GridColumn>
                </Grid>
            )}
        </Card>
    );
});
